import React from 'react';

const About = () => {
  return (
    <section id="about" className="wrap">
      <h2 className="section-title reveal">About</h2>
      <p className="section-desc reveal">
        I am a motivated and detail-oriented Computer Science and Technology undergraduate at Uva Wellassa University, with a strong foundation in full-stack development and a certified passion for UI/UX design. My technical skills span multiple programming languages and frameworks, including Java and JavaScript complemented by expertise in modern design tools. A collaborative team player with proven leadership in tech communities, I thrive on turning complex problems into elegant solutions and am eager to apply my abilities in a professional environment where I can continue to learn and contribute to innovative projects.
      </p>
      {/* Removed the three info cards as requested. */}
    </section>
  );
};

export default About;